import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivityModel } from '../user/activity/activity.model';
import { ActivityService } from '../user/activity/activity.service';
import { SubscriptionModel } from '../subscription/subscription.model';
import { SubscriptionService } from '../subscription/subscription.service';
import { CoreComponent } from '../../core/header/core.component';

@Component({
    selector: 'convfact-fiscaltabs',
    templateUrl: './fiscal-tabs.component.html',
    styleUrls: ['./fiscal.component.css'],
    standalone: false
})
export class FiscalTabsComponent implements OnInit {
  routes: object[];
  activity: ActivityModel[] = [];
  currentActivityUid: string;
  currentActivityName: string;
  subscriptionList: SubscriptionModel[] = [];

  constructor(
    private router: Router,
    public activityService: ActivityService,
    private core: CoreComponent
  ) {
    this.routes = [
      { label: 'Modelos Fiscales', link: 'fiscalModels' },
    ];
  }

  ngOnInit() {
    this.activityService.getActiveList().then(response => {
      this.activity = response;
    });

    this.activityService.loadData(this.core.activitySelected).then(response => {
      this.currentActivityName = response.name;
    });
  }
}